module.exports = __webpack_public_path__ + "img/zz9_2.d9024d74.png";